import { gsap } from "gsap";
import { on } from "delegated-events";

const closeOtherItems = (grid) => {
  grid.querySelectorAll('.callout-open-trigger[aria-expanded="true"]').forEach((trigger) => {
    const item = trigger.closest(".callout-item");
    const expandedItem = document.getElementById(trigger.getAttribute("aria-controls"));

    trigger.setAttribute("aria-expanded", "false");
    item.classList.remove("hidden");
    expandedItem.style.display = "none";
  });
};

const handleOpen = async (e) => {
  const grid = e.target.closest(".callout-grid");
  const button = e.target.closest("button");
  const item = e.target.closest(".callout-item");
  const expandedItem = document.getElementById(button.getAttribute("aria-controls"));
  const pos = parseInt(expandedItem.dataset.pos, 10);
  const numCols = parseInt(getComputedStyle(grid).getPropertyValue("--cols"), 10);
  const offset = pos % numCols;
  const order = offset === 0 ? pos - numCols : pos - offset;

  closeOtherItems(grid);

  button.setAttribute("aria-expanded", "true");
  item.classList.add("hidden");
  expandedItem.style.order = order;

  gsap.fromTo(
    expandedItem,
    { height: 0, opacity: 0, display: "block" },
    {
      height: "auto",
      opacity: 1,
      duration: 0.5,
      onComplete: () => {
        expandedItem.style.height = "auto";
      },
    },
  );
};

const handleClose = async (e) => {
  const expandedItem = e.target.closest(".callout-expanded-item");
  const item = document.querySelector(`[aria-controls="${expandedItem.id}"]`).closest(".callout-item");
  const openButton = item.querySelector(".callout-open-trigger");
  openButton.setAttribute("aria-expanded", "false");

  item.classList.remove("hidden");

  gsap.to(expandedItem, {
    height: 0,
    opacity: 0,
    duration: 0.5,
    display: "none",
  });
};

on("click", ".element-expandablecalloutgrid .callout-open-trigger", handleOpen);
on("click", ".element-expandablecalloutgrid .callout-close-trigger", handleClose);
